var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.333 8a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0M7.333 8a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0M3.333 8a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.833 8a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0M4 7.833a.167.167 0 1 0 0 .334.167.167 0 0 0 0-.334M6.833 8a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0M8 7.833a.167.167 0 1 0 0 .334.167.167 0 0 0 0-.334M10.833 8a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0M12 7.833a.167.167 0 1 0 0 .334.167.167 0 0 0 0-.334",
    clipRule: "evenodd"
  })));
};
export { SvgDots as ReactComponent };
export default __webpack_public_path__ + "51810fbdfc417064af26a68a87219831.svg";